<template >
    <div class="">
        <div>
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>
                    <i class="el-icon-lx-cascades"></i>
                    <el-popover
                            placement="bottom-start"
                            width="500"
                            trigger="hover"
                            >
                        <div slot="reference" class="sub-title"> 品牌商城管理（查看审核规则）</div>
                        <slot>
                            1、品牌销售商城申请审核<br/>
                            供应商会员填写品牌销售商城基本信息后，平台于3个工作日之内进行审核。<br/>

                            2、品牌销售商城信息修改<br/>
                            供应商会员修改品牌销售商城有效期、目录范围等内容，平台于5个工作日之内进行审核。<br/>

                            3、品牌销售商城内容模板审核<br/>
                            供应商会员应维护品牌销售商城模板的全部内容后再提交审核，维护内容不全或有缺失的内容模板会被审核拒绝。提交模板审核后，平台于5个工作日之内进行审核。<br/>

                            4、处罚<br/>

                            品牌销售商城存在违规行为，受到平台处罚。平台以电话或邮件等方式提前告知，时间不少于3个工作日。<br/>

                            5、品牌销售商城停用<br/>

                            由于自身业务变更，无法继续商城运营，须提前告知平台并在商城显著位置公开通知说明情况，时间不少于10个工作日。<br/>

                            6、产品目录申请审核<br/>

                            用户提出产品目录申请，平台及时对其进行资格审查，原则上审查时间不超过10个工作日，如有疑问请联系对应的服务管家单位。<br/>
                        </slot>
                    </el-popover>
<!--                    <el-tooltip placement="top" effect="light">-->


<!--                    </el-tooltip>-->
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="container">
            <el-form :inline="true" :model="query" ref="query">
                <el-form-item  label="商城名称" prop="storeName" >
                    <el-input   @keyup.enter.native="handleSearch" v-model.trim="query.storeName" ></el-input>
                </el-form-item>
                <el-form-item  label="商城申请状态" prop="storeStatus" >
                    <el-select v-model="query.storeStatus" clearable>
                        <el-option v-for="item in mallTypeListFilter" :value="item.key" :label="item.name" :key="item.key"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item  label="过期时间" prop="dateValue" >
                    <el-date-picker
                            v-model="query.dateValue"
                            format='yyyy年MM月dd日'
                            value-format="yyyy-MM-dd"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="时间下限"
                            end-placeholder="时间上限">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div class="search-btn-area">
                <el-button    @click="handleClear" class="search-reset-btn">重置</el-button>
                <el-button class="search-handle-btn" plain   @click="handleSearch">查询</el-button>

            </div>
        </div>
        <div class="container">
            <div class="flex-sb" style="margin-bottom: 20px;line-height:20px;align-items: center;float:right">
                <!-- <p class="table-title">商城列表</p> -->
                <el-button @click="handleAdd"  class="search-reset-btn" :style="{width:'100px'}">开通销售商城</el-button>
            </div>
            <div class="empty" v-if="dataEmpty">
                <p>您的品牌销售商城尚未开通，开通后可获得如下权益：</p>
                <p>搜索加权：在产品/商家搜索排名上可获得优先展示机会（同等条件下）</p>
                <p>定点推送：推送至采购商个人页面（采购需求涵盖此类商品）</p>
                <p>大型活动：优先获得易派客展会、会议、交流机会</p>
            </div>

            <div v-else>
                <el-table   border  v-loading="loading" :data="tableData"  style="width: 100%">
                    <el-table-column type="index" label="序号" width="50" align='center'></el-table-column>
                    <el-table-column prop="storeName" label="商城名称"></el-table-column>
                    <el-table-column prop="brandName" label="认证品牌"></el-table-column>
                    <el-table-column prop="disableSign" width="80" label="商城状态" :formatter="disableSignFormatter"></el-table-column>
                    <el-table-column prop="storeStatus" label="商城申请状态">
                        <template slot-scope="scope">
                            <el-tooltip placement="top" effect="light" :disabled="scope.row.storeStatus != 105 " >
                                <div slot="content" v-html="escape2Html(scope.row.rejectReason)"></div>
                                <div>{{statusFormatter(scope.row)}}</div>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column prop="templateStatus" label="商城装修状态">
                        <template slot-scope="scope">
                            <el-tooltip placement="top" effect="light" :disabled="scope.row.templateStatus != 4 ">
                                <div slot="content" v-if="scope.row.templateStatus == 4" v-html="escape2Html(scope.row.auditReason)"></div>
                                <div>{{templateStatusFormatter(scope.row)}}</div>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column prop="storeDeadline" label="过期时间"></el-table-column>
                    <el-table-column label="操作"    width="160px">
                        <template slot-scope="scope">
                            <!-- <el-button   size="mini" type="text" @click="handleEdit(scope.row,'/addBrandMall?type=edit')">管理基础信息</el-button > -->
                            <eui-btn type="link" size="20" class="table-handle-btn" style="margin-right: 10px;" :disabled='scope.row.storeStatus==102'   @click="handleEdit(scope.row,'/addBrandMall?type=edit')">管理基础信息</eui-btn >
                            <eui-btn type="link" size="20" class="table-handle-btn" :disabled='scope.row.storeStatus==101 || scope.row.storeStatus==102 || scope.row.storeStatus==104 || scope.row.disableSign==1' @click="handleEdit(scope.row,'/contentTemplate')">商城装修</eui-btn >
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination
                            prev-text="上一页"
                            next-text="下一页"
                            layout="total, sizes, prev, pager, next, jumper"
                            :page-sizes="[10, 20, 30, 40, 50, 60, 80, 100]"
                            :current-page="query.pageNum"
                            :page-size="query.pageSize"
                            :total="pageTotal"
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                    ></el-pagination>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import { mapMutations } from "vuex";
    import Api from '../../api/user/index'
    import {mallTypeList,templateStatusList} from '../../utils/globalData'
    export default {
        name: "agreementManage",
        components: {},
        props: {},
        data() {
            return {
                mallTypeList,
                templateStatusList,
                query:{
                    storeName:'',
                    storeStatus:'',
                    dateValue:'',
                    storeDeadlineStart:'',
                    storeDeadlineEnd:'',
                    pageNum:1,
                    pageSize:10
                },
                pageTotal:0,
                loading:false,
                tableData:[],
                dataEmpty:false,
                params:{
                    storeName:'',
                    storeStatus:'',
                    dateValue:'',
                    storeDeadlineStart:'',
                    storeDeadlineEnd:'',
                    pageNum:1,
                    pageSize:10
                }

            }
        },
        computed: {
            mallTypeListFilter() {
                let arr=[]
                this.mallTypeList.map(item=>{
                    if(item.key!=104){
                        arr.push(item)
                    }
                })
                return arr
            },
        },
        created() {
            this.getDataList('init')
        },
        methods: {
            ...mapMutations(["BRAND_INfO"]),
            // 销售商城状态 101：待提交 （已保存） 102：申请中 （待审核） 103：生效中 104：变更中（待审核） 105：审批拒绝'  106：已停用
            // 销售商城状态：已保存、待审核、生效中、审批拒绝、已停用。
            disableSignFormatter(row){
                let status=row.disableSign==1?'已禁用' :'已启用';
                return status;
            },
            statusFormatter(row){
                let status='';
                this.mallTypeList.map(item=>{
                    if(row.storeStatus==item.key){
                        if(item.key==101){
                            status='已保存'
                        }else if(item.key==102 || item.key==104){
                            status='待审核'
                        }else if(item.key==105){
                            status='审批拒绝(查看原因)'
                        }else {
                            status=item.name;
                        }
                    }
                })

                return status;
            },
            //1、已保存  2、待审核 3、审核通过  （待发布） 4、审核拒绝  5、已发布 （生效中）  6、变更保存中 （已保存） 7、变更审核中 （待审核）
            // 内容模板状态：已保存、待审核、待发布、审批拒绝、生效中。
            // 审核拒绝重新提交，状态仍显示为待审核，前端无需区分是否重新提交。
            templateStatusFormatter(row){
                let status='待创建';
                this.templateStatusList.map(item=>{
                    if(row.templateStatus==item.key){
                        if(item.key==3){
                            status='待发布'
                        }else if(item.key==5){
                            status='生效中'
                        }else if(item.key==6){
                            status='已保存'
                        }else if(item.key==7){
                            status='待审核'
                        }else if(item.key==4){
                            status='审核拒绝(查看原因)'
                        }else{
                            status=item.name;
                        }

                    }
                })
                return status;
            },
            handleAdd(){
                this.$router.push({path:'/addBrandMall'})
            },
            handleSearch(){
                this.getDataList(1)
            },
            handleClear(){
                this.$refs.query.resetFields()
                this.getDataList(1)
            },

            handleSizeChange(val){
                this.params.pageSize = val
                this.params.pageNum = 1
                this.getDataList(2)
            },
            handleCurrentChange(val){
                this.params.pageNum = val
                this.getDataList(2)
            },

            async getDataList(type){
                this.loading=true;
                if(this.query.dateValue){
                    this.query.storeDeadlineStart=this.query.dateValue[0];
                    this.query.storeDeadlineEnd=this.query.dateValue[1];
                }
                if(type==1){
                    this.query.pageNum=1;
                    this.query.pageSize=10;
                    this.params={
                        ...this.query
                    }
                }

                let res= await Api.queryStorePage(this.params);
                this.loading=false;
                if(res.code==200){
                    if(res.data.records.length==0 &&type ==1){
                        this.$alert('根据您的筛选条件，暂无匹配结果，请调整筛选条件后重试。', '提示', {
                            confirmButtonText: '确定'
                        });
                        this.$refs.query.resetFields()

                    }else{
                        this.tableData=res.data.records;
                        this.pageTotal=res.data.total;
                        this.queryRejectReason(this.tableData)
                    }
                    if(type=='init' && res.data.records.length==0){
                        this.dataEmpty=true;
                    }
                }

            },
            handleEdit(row,path){
                this.BRAND_INfO(row);
                this.$router.push(path)
            },
            async queryRejectReason(tableArr){
                if(tableArr){
                    for(let i=0;i<tableArr.length;i++){
                        if(tableArr[i].templateStatus == 4){
                            let params = {
                                templateId : tableArr[i].templateId
                            }
                            let res = await Api.queryRejectReason(params)
                            this.$set(tableArr[i],'auditReason',res.data)
                        }
                    }
                }
            },
            escape2Html(str) {
                //转义字符转换普通字符的方法
                if(!str){
                    return  '无'
                }
                return  (str + '').replace(/\n/g,"<br/>")
            },

        }

    }
</script>

<style scoped>
.sub-title{
  position: relative;
  top:-14px
}
    .empty{
        border:1px solid #dcdfe6;
        padding:20px 20px 20px 100px;
        line-height: 36px;
        color: #333;
        font-size: 18px;
    }
</style>
